<select [(ngModel)]="selectedQuery">
  <option
    *ngFor="let query of queries"
    [ngValue]="query"
    [selected]="query === 'Device'">
    {{ query }}
  </option>
</select>

<div class="input-group">
  <content-with-label label="Serial Number">
    <input
      name="serialNumber"
      type="text"
      [(ngModel)]="serialNumberFilter" />
  </content-with-label>

  <content-with-label
    *ngIf="selectedQuery === 'Install'"
    label="Start Date">
    <input
      id="start-date"
      name="start-date"
      type="datetime-local"
      [(ngModel)]="startDateFilter" />
  </content-with-label>

  <content-with-label
    *ngIf="selectedQuery === 'Install'"
    label="End Date">
    <input
      id="end-date"
      name="end-date"
      type="datetime-local"
      [(ngModel)]="endDateFilter" />
  </content-with-label>

  <content-with-label label="Company ID">
    <input
      name="companyId"
      type="number"
      [(ngModel)]="companyIdFilter" />
  </content-with-label>

  <content-with-label
    class="multi-select-input"
    label="Status Criteria">
    <ng-select
      placeholder="Select Status Criteria (Pass/Fail)"
      [items]="statusProperties"
      [multiple]="true"
      [(ngModel)]="selectedHealthParams">
      <ng-template ng-header-tmp>
        <div class="status-criteria-header">
          <button
            class="lx-btn lx-btn-text"
            (click)="selectAll()">
            Select all
          </button>
          <button
            class="lx-btn lx-btn-text"
            (click)="unselectAll()">
            Unselect all
          </button>
        </div>
      </ng-template>
    </ng-select>
  </content-with-label>

  <dcc-loading-indicator *ngIf="isLoading"></dcc-loading-indicator>
  <dcc-search-button
    *ngIf="!isLoading"
    (search)="onSearchClick()"></dcc-search-button>
  <dcc-reset-button
    *ngIf="!isLoading"
    (reset)="reset()"></dcc-reset-button>
</div>
